import { render } from "./CareerDevelopment.vue?vue&type=template&id=dd52414c&scoped=true"
import script from "./CareerDevelopment.vue?vue&type=script&lang=js"
export * from "./CareerDevelopment.vue?vue&type=script&lang=js"

import "./CareerDevelopment.vue?vue&type=style&index=0&id=dd52414c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd52414c"]])

export default __exports__